// adapted from https://www.npmjs.com/package/xregexp-lookbehind
import _ from 'lodash'

import XRegExp from 'xregexp'
import XRegExpLookBehind from 'xregexp-lookbehind'

_.merge(XRegExp, XRegExpLookBehind)
